module.exports = __webpack_public_path__ + "static/media/close-black.a5b3f67e.svg";